import { render, staticRenderFns } from "./feedback-details.vue?vue&type=template&id=34cc6e00&"
import script from "./feedback-details.vue?vue&type=script&lang=js&"
export * from "./feedback-details.vue?vue&type=script&lang=js&"
import style0 from "./feedback-details.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports